(function () {
  document.querySelectorAll('.pq-wrap').forEach(function (root) {
    var publicKey = root.dataset.publicKey;
    var listId = root.dataset.listId;

    var introEl = root.querySelector('[data-pq-step="intro"]');
    var progressEl = root.querySelector('[data-pq-progress]');
    var progressFill = root.querySelector('[data-pq-progress-fill]');
    var questionEls = Array.prototype.slice.call(root.querySelectorAll('[data-pq-question]'));
    var captureEl = root.querySelector('[data-pq-capture]');
    var loadingEl = root.querySelector('[data-pq-loading]');
    var resultEls = Array.prototype.slice.call(root.querySelectorAll('[data-pq-result]'));
    var startBtn = root.querySelector('[data-pq-start]');
    var submitBtn = root.querySelector('[data-pq-submit]');
    var errorEl = root.querySelector('[data-pq-error]');

    var totalSteps = questionEls.length + 1; // + capture step
    var current = -1; // -1 = intro
    var scores = {};
    var answers = [];

    function showStep(index) {
      questionEls.forEach(function (q) { q.hidden = true; });
      captureEl.hidden = true;
      introEl.hidden = true;
      if (index < questionEls.length) {
        questionEls[index].hidden = false;
      } else {
        captureEl.hidden = false;
      }
      progressEl.hidden = false;
      progressFill.style.width = Math.round(((index + 1) / totalSteps) * 100) + '%';
    }

    startBtn.addEventListener('click', function () {
      current = 0;
      showStep(current);
    });

    questionEls.forEach(function (qEl) {
      qEl.querySelectorAll('.pq-option').forEach(function (optBtn) {
        optBtn.addEventListener('click', function () {
          var persona = optBtn.dataset.persona;
          scores[persona] = (scores[persona] || 0) + 1;
          answers.push({ question: qEl.dataset.index, persona: persona, label: optBtn.textContent.trim() });
          qEl.querySelectorAll('.pq-option').forEach(function (b) { b.classList.remove('pq-selected'); });
          optBtn.classList.add('pq-selected');
          setTimeout(function () {
            current += 1;
            showStep(current);
          }, 200);
        });
      });
    });

    function topPersona() {
      var best = null, bestScore = -1;
      var order = ['social_butterfly', 'chill_sipper', 'deep_relaxer', 'active_recoverer'];
      order.forEach(function (p) {
        var s = scores[p] || 0;
        if (s > bestScore) { bestScore = s; best = p; }
      });
      return best;
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    async function klaviyoFetch(path, body) {
      try {
        var resp = await fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + publicKey, {
          method: 'POST',
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'revision': '2026-01-15'
          },
          body: JSON.stringify(body)
        });
        return resp;
      } catch (e) {
        console.warn('Klaviyo request failed', path, e);
        return null;
      }
    }

    async function syncToKlaviyo(persona, email, phone, emailConsent, smsConsent) {
      var props = { quiz_result: persona, quiz_answers: answers.map(function (a) { return a.persona; }) };

      // 1. Upsert profile with quiz_result property
      var profileAttrs = { email: email, properties: props };
      if (phone) profileAttrs.phone_number = phone;
      await klaviyoFetch('profiles', {
        data: { type: 'profile', attributes: profileAttrs }
      });

      // 2. Subscribe to list with explicit consent
      var subs = {};
      if (emailConsent) subs.email = { marketing: { consent: 'SUBSCRIBED' } };
      if (phone && smsConsent) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
      if (Object.keys(subs).length > 0) {
        var subProfileAttrs = { email: email, subscriptions: subs };
        if (phone) subProfileAttrs.phone_number = phone;
        await klaviyoFetch('subscriptions', {
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: subProfileAttrs } } },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        });
      }

      // 3. Track Completed Quiz event
      await klaviyoFetch('events', {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'Completed Quiz' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      });
    }

    submitBtn.addEventListener('click', function () {
      errorEl.hidden = true;
      var ageEl = root.querySelector('[data-pq-age]');
      var emailEl = root.querySelector('[data-pq-email]');
      var phoneEl = root.querySelector('[data-pq-phone]');
      var consentEmailEl = root.querySelector('[data-pq-consent-email]');
      var consentSmsEl = root.querySelector('[data-pq-consent-sms]');

      if (ageEl && !ageEl.checked) { showError('Please confirm you are 21 or older to continue.'); return; }
      var email = emailEl.value.trim();
      if (!isValidEmail(email)) { showError('Please enter a valid email address.'); return; }

      var phone = phoneEl.value.trim();
      var persona = topPersona();

      if (typeof fbq === 'function') {
        fbq('track', 'Lead', {
          content_name: 'Find Your Vibe Quiz',
          content_category: 'quiz_lead',
          value: 0,
          currency: 'USD'
        });
      }

      captureEl.hidden = true;
      progressEl.hidden = true;
      loadingEl.hidden = false;

      syncToKlaviyo(persona, email, phone, consentEmailEl.checked, consentSmsEl.checked).finally(function () {
        loadingEl.hidden = true;
        resultEls.forEach(function (r) {
          r.hidden = r.dataset.persona !== persona;
        });
      });
    });

    resultEls.forEach(function (r) {
      var restartBtn = r.querySelector('[data-pq-restart]');
      if (restartBtn) {
        restartBtn.addEventListener('click', function () {
          resultEls.forEach(function (el) { el.hidden = true; });
          scores = {};
          answers = [];
          current = -1;
          introEl.hidden = false;
          progressEl.hidden = true;
          root.querySelectorAll('.pq-option').forEach(function (b) { b.classList.remove('pq-selected'); });
          var emailEl2 = root.querySelector('[data-pq-email]');
          if (emailEl2) emailEl2.value = '';
        });
      }
    });
  });
})();
